<palantir-accordion [title]="definition().label" [open]="true">
  @if (canShowFilter()) {
    <div class="search-input__container">
      @if (definition().description?.length) {
        <palantir-text class="search-input__description" size="base" type="description">{{
          definition().description
        }}</palantir-text>
      }
      <palantir-input prefix="search-outline">
        <input
          type="text"
          [placeholder]="definition().placeholder ?? ''"
          [formControl]="searchControl"
        />
        <palantir-filter-modal-error-display
          palantir-input-error
          [control]="control()"
          [validatorsMessages]="definition().validatorsMessages"
        />
      </palantir-input>

      @if (searchControl.dirty) {
        @if (isLoading()) {
          <div class="search-input__loading-container">
            @for (_ of [].constructor(5); track $index) {
              <palantir-skeleton class="search-input__skeleton-item" />
            }
          </div>
        } @else {
          <div class="search-input__options palantir-scrollbar">
            @for (item of items(); track item.value) {
              <button
                type="button"
                class="search-input__options__option"
                (click)="selectItem(item)"
              >
                @if (isMultiSearch()) {
                  <palantir-checkbox [attr.aria-selected]="isChecked(item)" />
                }

                @if (isSingleSearch()) {
                  <palantir-radio [attr.aria-selected]="isChecked(item)" />
                }

                <palantir-filter-modal-option [option]="item" />
              </button>
            } @empty {
              @if (!searchControl.pristine) {
                <div class="search-input__empty-message">
                  <palantir-icon name="search-outline" class="search-input__empty-message__icon" />
                  <palantir-text size="base" type="description">{{
                    definition().emptyMessage
                  }}</palantir-text>
                </div>
              }
            }
          </div>
        }
      }
    </div>
  } @else {
    <div class="filter-dialog__banner">
      <palantir-icon name="info-outline" class="filter-dialog__banner__icon" />
      <palantir-text size="base" type="description">{{
        definition().dependsOn?.placeholder
      }}</palantir-text>
    </div>
  }
</palantir-accordion>
